
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.277","height":"18.569"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)","fill":"none","stroke":"#959da1"}},[_c('path',{attrs:{"d":"M10.478 11.891a1.782 1.782 0 11-1.782-1.782 1.782 1.782 0 011.782 1.782z"}}),_c('rect',{attrs:{"width":"17.277","height":"11.611","rx":"2.448","transform":"translate(0 5.957)","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.07 5.958S3.738 0 8.639 0s4.688 5.958 4.688 5.958","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    